import { createBrowserHistory, createMemoryHistory } from "history";

export const createHistory = ({ serverSide, location }) => {
  const history = serverSide ? createMemoryHistory() : createBrowserHistory();
  history.replace(location);
  return history;
};
